import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {Input} from 'reactstrap';
import {resetPasswordRequest} from "utils/api";
import {SpinnerButton} from 'common/SpinnerButton';
import './style.css';
import {AuthLayout} from "./AuthLayout";
import {InputWithError} from "../../common/InputWithError";

export const ForgotPassword = () => {
    const [submitting, setSubmitting] = useState(false);
    const [email, setEmail] = useState('');
    const [isEmailSent, setIsEmailSent] = useState(false);
    const [errors, setErrors] = useState(null);

    const onSubmit = async () => {
        setSubmitting(true);

        try {
            const params = {
                email,
                confirmation_url: `${window.location.origin}/reset-password`,
            };
            await resetPasswordRequest(params);
            setIsEmailSent(true);
        } catch (err) {
            setErrors({errors: {'email': [{'message': err.message}]}});
        }

        setSubmitting(false);
    };

    useEffect(() => {
        setErrors(null);
    }, [email]);

    const forgotPasswordForm = () => {
        return (
            <div className="d-flex justify-content-center align-items-center flex-grow-1">
                <div className="text-center w-100 px-3 px-md-5">
                    <div className="login-box shadow-sm">
                        {!isEmailSent ? (
                            <>
                                <h4 className="mb-3 login-title" style={{color: '#6EB5D2'}}>Forgot your password?</h4>
                                <h5 className="mb-5" style={{color: '#737373'}}>Enter your email to reset it. </h5>
                                <div className="mb-5 text-start">
                                    <label htmlFor="email" className="form-label">Email</label>
                                    <InputWithError
                                        id="email"
                                        name="email"
                                        value={email}
                                        type="email"
                                        onChange={setEmail}
                                        errorObj={errors}
                                        autoComplete="off"
                                        className="rounded-pill"
                                    />
                                </div>
                                <div className="d-grid mb-4">
                                    <SpinnerButton
                                        color="primary"
                                        block
                                        disabled={email < 1}
                                        onClick={onSubmit}
                                        submitting={submitting}
                                        title="Confirm"
                                        className="text-bold rounded-pill"
                                    />
                                </div>
                            </>
                        ) : (
                            <>
                                <h4 className="mb-3 login-title">Check your Email</h4>
                                <p className="mb-4 mt-3">
                                    An email containing a password reset link was sent to the email you
                                    provided. Please click the link in the
                                    email and follow the instructions provided.
                                </p>
                            </>
                        )
                        }
                        <div style={{marginTop: '4rem', marginBottom: '8rem'}}>
                            Return to &nbsp;
                            <Link className="underline-important" to="/signin">
                                Log In
                            </Link> &nbsp; page
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return <AuthLayout authForm={forgotPasswordForm()}/>
};
